orders-planner-line-ui-menu(class="{'phase-exist': this.opts.hasSpecificPhase }")
  span.btn-menu.btn.btn-sm.btn-success.btn-outline-success.waves-effect.waves-dark.icon-btn(onClick="{onClickMenu}")
    i.feather.icon-menu
  script(type="typescript").
    this.mixin('orders.planner.line-ui.menu');
    
